import { BrowserRouter as Router, useLocation } from "react-router-dom";

import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import AppRoutes from "./routes/AppRoutes";

import AuthService from "./services/authService";

import {
  setUserData,
  clearAuthState,
  setAuthInitialized,
} from "./store/slices/userSlice";

/* =========================================================
   APP WRAPPER
   ========================================================= */

function AppWrapper() {
  const location = useLocation();
  const dispatch = useDispatch();

  const [isInitializing, setIsInitializing] = useState(true);
  const { isAuthenticated } = useSelector((state) => state.user);
  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const user = await AuthService.getCurrentUser();

        if (user) {
          dispatch(
            setUserData({
              user,
              role: user?.roles?.[0]?.roleName || null,
              isAuthenticated: true,
            }),
          );
        } else {
          dispatch(clearAuthState());
        }
      } catch (error) {
        dispatch(clearAuthState());
      } finally {
        // VERY IMPORTANT
        dispatch(setAuthInitialized(true));
        setIsInitializing(false);
      }
    };

    initializeAuth();
  }, [dispatch]);
  const authRoutes = [
    "/",
    "/login",
    "/forgotpassword",
    "/changepassword",
    "/resetpassword",
  ];
  const isAuthRoute = authRoutes.includes(location.pathname);
  const hideLayout = isAuthRoute && !isAuthenticated;

  if (isInitializing) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#f5f5f5",
        }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  return (
    <>
      {!hideLayout && <Header />}

      <div className="page-container">
        <AppRoutes />
      </div>

      {!hideLayout && <Footer />}
    </>
  );
}

/* =========================================================
   APP
   ========================================================= */

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}
